var SPACER = {
  /**
   * 2px
   */
  x2small: '0.125rem',

  /**
   * 4px
   */
  xsmall: '0.25rem',

  /**
   * 8px
   */
  small: '0.5rem',

  /**
   * 16px
   */
  base: '1rem',

  /**
   * 16px
   */
  medium: '1rem',

  /**
   * 24px
   */
  large: '1.5rem',

  /**
   * 32px
   */
  xlarge: '2rem',

  /**
   * 40px
   */
  x2large: '2.5rem',

  /**
   * 48px
   */
  x3large: '3rem',

  /**
   * 56px
   */
  x4large: '3.5rem',

  /**
   * 64px
   */
  x5large: '4rem'
};

export { SPACER as default };
